import { LegalPage, Section } from "@/components/LegalPage";

export default function Aup() {
  return (
    <LegalPage title="Acceptable Use Policy" testId="aup-title">
      <Section title="1. Purpose">
        <p>This Acceptable Use Policy ("AUP") governs how you may and may not use BeatCredsi™. It is incorporated by reference into our Terms of Service.</p>
      </Section>

      <Section title="2. Account &amp; Identity">
        <p>You must:</p>
        <ul>
          <li>Provide accurate identity information.</li>
          <li>Not impersonate another producer, artist, label, or rights-holder.</li>
          <li>Not register a username that infringes another person's trademark or name.</li>
          <li>Not create multiple accounts to circumvent founding-seat limits, founding pricing, or exam retake throttles.</li>
        </ul>
      </Section>

      <Section title="3. Assessment &amp; Score Integrity">
        <p>You may not:</p>
        <ul>
          <li>Submit falsified information in the assessment to inflate your BeatCredsi Score.</li>
          <li>Use scripts, bots, or automation to take the assessment or exams on your behalf.</li>
          <li>Share, sell, or distribute exam questions or answers.</li>
          <li>Attempt to reverse-engineer the scoring algorithm.</li>
        </ul>
      </Section>

      <Section title="4. Certifications">
        <p>Certifications are personal and non-transferable. Cheating, sharing exam contents, or impersonating another user during an exam will result in:</p>
        <ul>
          <li>Revocation of the certification</li>
          <li>Removal of the corresponding score boost</li>
          <li>Potential account suspension or termination</li>
        </ul>
      </Section>

      <Section title="5. Evidence Submissions">
        <p>When uploading evidence (screenshots, PDFs, certificates) for verification, you must:</p>
        <ul>
          <li>Upload only documents that actually belong to or pertain to you.</li>
          <li>Not upload forged, edited, fabricated, or AI-generated documents intended to deceive.</li>
          <li>Not upload content containing third-party personal data without their consent.</li>
        </ul>
        <p>Fraudulent submissions will trigger immediate account termination.</p>
      </Section>

      <Section title="6. Public Passport Content">
        <p>You may not include on your public Passport:</p>
        <ul>
          <li>Hate speech, harassment, threats, sexually explicit content, or content that exploits minors.</li>
          <li>Content that infringes copyrights, trademarks, publicity rights, or privacy rights.</li>
          <li>Misleading credit claims (e.g., listing yourself on songs you did not produce or write).</li>
          <li>Promotional material for illegal goods or services.</li>
          <li>Links to malware, phishing sites, or sites that violate our AUP.</li>
        </ul>
      </Section>

      <Section title="7. Technical Abuse">
        <p>You may not:</p>
        <ul>
          <li>Probe, scan, or test vulnerabilities of the Platform without written authorization.</li>
          <li>Send automated, high-volume, or aggressive requests that degrade service for others.</li>
          <li>Attempt to bypass authentication, rate limits, or paywalls.</li>
          <li>Scrape Passport pages in bulk for resale or competitive intelligence.</li>
          <li>Reverse-engineer, decompile, or extract source code.</li>
        </ul>
      </Section>

      <Section title="8. Communication Channels">
        <p>If we add direct-messaging, comment, or community features in the future, the following are prohibited:</p>
        <ul>
          <li>Spam, unsolicited promotions, or chain messages.</li>
          <li>Harassment, doxing, hate speech, or threats.</li>
          <li>Sharing other users' personal contact information without consent.</li>
        </ul>
      </Section>

      <Section title="9. Payment Abuse">
        <p>You may not:</p>
        <ul>
          <li>Use stolen, fraudulent, or unauthorized payment methods.</li>
          <li>Initiate chargebacks without first contacting <a href="mailto:contact@onlymartian.com">contact@onlymartian.com</a>.</li>
          <li>Sign up under a different identity to evade a prior account suspension.</li>
        </ul>
      </Section>

      <Section title="10. Enforcement">
        <p>Violations may result in, at our sole discretion:</p>
        <ul>
          <li>Warning</li>
          <li>Removal of offending content</li>
          <li>Revocation of certifications and score boosts</li>
          <li>Suspension or permanent termination of your account</li>
          <li>Forfeiture of paid membership without refund</li>
          <li>Referral to law enforcement where applicable</li>
        </ul>
      </Section>

      <Section title="11. Reporting Abuse">
        <p>To report a violation of this AUP, email <a href="mailto:contact@onlymartian.com">contact@onlymartian.com</a> with the subject "AUP Report" and include URLs, screenshots, and a description.</p>
      </Section>

      <Section title="12. Updates">
        <p>We may update this AUP as the Platform evolves. Material changes will be announced via email or in-app notice.</p>
      </Section>
    </LegalPage>
  );
}
